import { render } from "./DeviationSearchWarningTable.vue?vue&type=template&id=c1dbb97e"
import script from "./DeviationSearchWarningTable.vue?vue&type=script&lang=ts"
export * from "./DeviationSearchWarningTable.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBanner,QIcon,QTd,QBtn});
